import script from "./DictionaryTemplates.vue?vue&type=script&lang=ts&setup=true"
export * from "./DictionaryTemplates.vue?vue&type=script&lang=ts&setup=true"

import "./DictionaryTemplates.vue?vue&type=style&index=0&id=0a9178d4&scoped=true&lang=scss"
import "./DictionaryTemplates.vue?vue&type=style&index=1&id=0a9178d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a9178d4"]])

export default __exports__